import { combineReducers } from 'redux-immutable'
import teamListReducer from './team-list-reducer'
import teamCreateReducer from './team-create-reducer'
import teamEditReducer from './team-edit-reducer'
import teamGetReducer from './team-get-reducer'
import teamDeactivateReducer from './team-deactivate-reducer'
import teamExportReducer from './team-export-reducer'

export default combineReducers({
  teamList: teamListReducer,
  teamCreate: teamCreateReducer,
  teamEdit: teamEditReducer,
  teamGet: teamGetReducer,
  teamDeactivate: teamDeactivateReducer,
  teamExport: teamExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/team/index.js